import { apiCall } from './apiHelpers';
import { authFetch } from './api';

export const subscriptionAPI = {
  // Get all available subscription plans
  getPlans: async () => {
    return apiCall(authFetch, '/subscription/plans');
  },

  // Get current user subscription
  getCurrentSubscription: async () => {
    return apiCall(authFetch, '/subscription/current');
  },

  // Create new subscription
  createSubscription: async (planId, paymentMethodId = null) => {
    return apiCall(authFetch, '/subscription/subscribe', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        plan_id: planId,
        payment_method_id: paymentMethodId,
      }),
    });
  },

  // Change subscription plan
  changePlan: async (planId) => {
    return apiCall(authFetch, `/subscription/change-plan/${planId}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
    });
  },

  // Cancel subscription
  cancelSubscription: async (reason = '') => {
    return apiCall(authFetch, '/subscription/cancel', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ reason }),
    });
  },

  // Get billing history
  getBillingHistory: async () => {
    return apiCall(authFetch, '/subscription/billing-history');
  },

  // Get feature usage
  getFeatureUsage: async (accountId) => {
    if (accountId) {
      return apiCall(authFetch, `/subscription/features/usage?accountId=${accountId}`);
    }
    return apiCall(authFetch, '/subscription/features/usage');
  },

  // Check feature access
  checkFeatureAccess: async (feature) => {
    return apiCall(authFetch, '/subscription/features/check-access', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ feature }),
    });
  },
}; 